import indexTemplate from './views/index.tpl.html';
import PosDefaultController from './controllers/pos-index-controller';

angular
    .module('festzelt-os.modules.pos')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.pos', {
            abstract: true,
            url: '/pos/',
            template: '<ui-view/>',
            data: {
                pageTitle: 'POS',
                showBackBtn: true
            }
        })
        .state('app.pos.main', {
            url: '',
            sticky: true,
            data: {
                bodyClass: 'wide',
                onlyContent: true
            },
            templateUrl: indexTemplate,
            controller: PosDefaultController,
            controllerAs: 'vm'
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/pos/routes.js